export default {"src":"/_next/static/media/ml-logo-white.1a89d735.svg","height":40,"width":180,"blurWidth":0,"blurHeight":0};